function collectCanvasColumns(node, path, out) {
    if (!node || !Array.isArray(node.elements)) return
    node.elements.forEach((child, i) => {
        if (!child) return
        const childPath = path + '.elements[' + i + ']'
        if (child.dragDrop === 'canvasColumn') {
            out.push({ path: childPath, element: child })
            return
        }
        if (child.dragDrop === 'canvasHolder') return
        collectCanvasColumns(child, childPath, out)
    })
}

function getCanvasColumns(elementData, holderPath) {
    const out = []
    collectCanvasColumns(elementData, holderPath || '', out)
    return out
}

/**
 * Pick which column a pointer is over. Falls back to the nearest column, then 0.
 * @param {number} clientX
 * @param {{left:number, right:number}[]|null|undefined} columnRects
 * @returns {number}
 */
function pickDropColumnIndex(clientX, columnRects) {
    if (!columnRects || columnRects.length === 0) return 0
    for (let i = 0; i < columnRects.length; i++) {
        const rect = columnRects[i]
        if (!rect) continue
        if (clientX >= rect.left && clientX <= rect.right) return i
    }
    let best = 0
    let bestDist = Infinity
    for (let i = 0; i < columnRects.length; i++) {
        const rect = columnRects[i]
        if (!rect) continue
        const mid = (rect.left + rect.right) / 2
        const dist = Math.abs(clientX - mid)
        if (dist < bestDist) {
            bestDist = dist
            best = i
        }
    }
    return best
}

function getDropColumn(elementData, holderPath, clientX, columnRects) {
    const columns = getCanvasColumns(elementData, holderPath)
    if (!columns.length) return null
    const index = pickDropColumnIndex(clientX, columnRects)
    return columns[Math.min(index, columns.length - 1)] || null
}

function collectColumnRects(rootNode) {
    if (!rootNode || !rootNode.querySelectorAll) return []
    const lpRow = rootNode.querySelector ? rootNode.querySelector('.lp-row') : null
    const scope = lpRow || rootNode
    return Array.from(scope.querySelectorAll('[data-type="column"]'))
        .filter((col) => !lpRow || col.closest('.lp-row') === lpRow)
        .map((el) => el.getBoundingClientRect())
}

export { collectCanvasColumns, collectColumnRects, getCanvasColumns, getDropColumn, pickDropColumnIndex }
